"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = remove;
const utils_1 = require("@aws-amplify/core/internals/utils");
const remove_1 = require("./internal/remove");
// Overload signatures above are the public contract; the impl is intentionally untyped and shape is enforced by resolveCtxArgs.
function remove(...args) {
    const [ctx, input] = (0, utils_1.resolveCtxArgs)(args);
    // Narrowing is required: removeInternal is overloaded and TypeScript cannot resolve the union argument without discriminating.
    if ('key' in input) {
        return (0, remove_1.remove)(ctx, input);
    }
    else {
        return (0, remove_1.remove)(ctx, input);
    }
}
